export default __webpack_public_path__ + "static/star-circle-a20ecae9de8eda905cf5b1ce5d2f9a1f.png";